export enum CarStatus {
  ORDERED = 'ORDERED',
  FLOAT_IN = 'FLOAT_IN',
  FLOAT_OUT = 'FLOAT_OUT',
}
